import { createFileRoute, Outlet } from '@tanstack/react-router';
import {
  SubNavbarWrapper,
  WithBannerSubNavbarWrapper,
} from 'components/App/style/App.style';
import { BettingWarningBanner } from 'components/betting-warning-banner';
import isCountryWithBanner from 'components/betting-warning-banner/utils/is-country-with-banner';
import { useIsNavbarHidden } from 'components/Navbar/hooks/use-is-navbar-hidden';
import Navbar from 'components/Navbar/Navbar.component';
import SiteNavigation from 'components/SiteNavigation/SiteNavigation.component';
import UrlControlledModals from 'components/UrlControlledModals/UrlControlledModals.component';
export const Route = createFileRoute('/_auth/_layout_with_full_navigation')({
  component: LayoutWithFullNavigation,
});

function LayoutWithFullNavigation() {
  const isNavbarHidden = useIsNavbarHidden();
  const SubNavbarWrapperComponent = isCountryWithBanner()
    ? WithBannerSubNavbarWrapper
    : SubNavbarWrapper;
  return (
    <>
      <UrlControlledModals />
      <Navbar />
      <BettingWarningBanner />
      <SubNavbarWrapperComponent isNavbarHidden={isNavbarHidden}>
        <SiteNavigation />
        <Outlet />
      </SubNavbarWrapperComponent>
    </>
  );
}
